import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Content,
  ImageContainer,
  LazyImage,
} from './ImageContentSection.styled';

const ImageContentSection = ({
  children,
  breakpoints,
  widths,
  aspectRatios,
  src,
  alt,
  additionalImageComponent,
}) => (
  <Container>
    <ImageContainer>
      <LazyImage
        breakpoints={breakpoints}
        widths={widths}
        aspectRatios={aspectRatios}
        src={src}
        alt={alt}
      />
      {additionalImageComponent}
    </ImageContainer>
    <Content>{children}</Content>
  </Container>
);

ImageContentSection.propTypes = {
  children: PropTypes.node.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  aspectRatios: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]).isRequired,
  breakpoints: PropTypes.arrayOf(PropTypes.number),
  widths: PropTypes.arrayOf(PropTypes.number),
  additionalImageComponent: PropTypes.node,
};

ImageContentSection.defaultProps = {
  breakpoints: undefined,
  widths: undefined,
  additionalImageComponent: null,
};

export default ImageContentSection;
